import React, { useState, forwardRef, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Search, LocationOn } from "@material-ui/icons";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import axios from "axios";
import MaterialTable from "material-table";
import format from "date-fns/format";
import Skeleton from "@material-ui/lab/Skeleton";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

import View from "views/dialog/ViewPreRegistration";
import Location from "../dialog/LocationPreRegistration";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function TableList() {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [idRow, setIdRow] = useState("");
  const [openView, setopenView] = useState(false);
  const [openBackdrop, setoOpenBackdrop] = useState(false);
  const [openLocation, setOpenLocation] = useState(false);
  const [nombre, setNombre] = useState("");
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [count, setCount] = useState(0);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const tableIcons = {
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  };

  const [state] = useState({
    columns: [
      {
        title: "-",
        field: "",
        filtering: false,
        render: (rowData) => (
          <Tooltip title="Ubicación" aria-label="Ubicación">
            <IconButton
              aria-label="account of current user"
              aria-controls="location"
              aria-haspopup="true"
              onClick={location(rowData)}
              color="inherit"
              size="small"
            >
              <LocationOn className={classes.iconStyle} />
            </IconButton>
          </Tooltip>
        ),
        width: 1,
        cellStyle: {
          borderBottom: "1px solid rgb(241, 241, 241)",
          textAlign: "center",
        },
        // headerStyle: { textAlign: "right" },
      },
      {
        title: "Negocio",
        field: "name",
        width: "25%",
        cellStyle: {
        //  whiteSpace: "nowrap",
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 14,
        },
      },
      {
        title: "Organización",
        field: "organization_type_name",
        render: (rowData) =>
          rowData.organization_type_name !== "Otros"
            ? rowData.organization_type_name
            : rowData.organization_type_another === null
            ? rowData.organization_type_name
            : rowData.organization_type_another,
        width: "20%",
        cellStyle: {
         // whiteSpace: "nowrap",
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 14,
        },
      },
      {
        title: "Sector económico",
        field: "economic_sector_name",
        render: (rowData) =>
          rowData.economic_sector_name !== "Otros"
            ? rowData.economic_sector_name
            : rowData.economic_sector_another === null
            ? rowData.economic_sector_name
            : rowData.economic_sector_another,
        width: "20%",
        cellStyle: {
         // whiteSpace: "nowrap",
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 14,
        },
      },
      {
        title: "Fecha de registro",
        field: "date_created",
        render: (rowData) =>
          format(new Date(rowData.date_created), "dd-MM-yyyy kk:mm:ss"),
        width: "20%",
        cellStyle: {
        //  whiteSpace: "nowrap",
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 14,
          textAlign: "center",
        },
      },
    ],
  });

  useEffect(() => {
    const consultar = () => {
      axios
        .get(`${urlServices}preRegisters/all`, {
          headers: {
            application: keyAplication,
          },
        })
        .then(
          (response) => {
            setRows(response.data);
            setCount(response.data.length);
            setLoader(false);
          },
          (error) => {
            console.log(error);
            setRows([]);
            setError(true);
          }
        );
    };
    consultar();
  }, [keyAplication, urlServices]);

  const RefreshTable = () => {
    setoOpenBackdrop(true);

    axios
      .get(`${urlServices}preRegisters/all`, {
        headers: {
          application: keyAplication,
        },
      })
      .then(
        (response) => {
          setoOpenBackdrop(false);
          setRows(response.data);
          setCount(response.data.length);
        },
        (error) => {
          console.log(error);
          setRows([]);
          setError(true);
          setoOpenBackdrop(false);
        }
      );
  };

  const handleCloseView = () => {
    setopenView(false);
  };

  /*const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };*/

  const handleCloseLocation = () => {
    setOpenLocation(false);
  };

  const location = (event) => () => {
    setOpenLocation(true);
    setIdRow(event.id);
    setLatitude(event.lat);
    setLongitude(event.lon);
    setNombre(event.name);
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardBody>
            <h4 className={classes.cardTitleGraphs}>
              Listado de la comunidad del ecosistema
            </h4>
            <h6 className={classes.cardTitleGraphs}>
              Registros realizados: <b>{count}</b>
            </h6>
            {error ? (
              <Alert severity="error">
                Error en la consulta con sel servidor.
              </Alert>
            ) : (
              ""
            )}
            {loader ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Box sx={{ width: "100%" }}>
                    <Skeleton
                      width="40%"
                      height={40}
                      style={{ float: "right" }}
                    />
                    <Skeleton width="100%" height={300} />
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <MaterialTable
                title=""
                columns={state.columns}
                style={{
                  boxShadow: "unset",
                  border: "1px solid rgb(241, 241, 241)",
                }}
                data={rows}
                localization={{
                  pagination: {
                    labelRowsSelect: "Filas",
                    labelDisplayedRows: " {from}-{to} de {count}",
                    firstTooltip: "Primera página",
                    previousTooltip: "Previo",
                    nextTooltip: "Siguiente",
                    lastTooltip: "Ultima página",
                  },
                  toolbar: {
                    // nRowsSelected: '{0} row(s) selected',
                    searchTooltip: "Filtrar",
                    searchPlaceholder: "Buscar",
                  },
                  header: {
                    actions: " --- ",
                  },
                  body: {
                    emptyDataSourceMessage: "No hay datos.",
                    filterRow: {
                      filterTooltip: "Filtro",
                    },
                  },
                }}
                actions={[
                  {
                    icon: "search",
                    tooltip: "Ver",
                    onClick: (event, rowData) => {
                      setopenView(true);
                      setIdRow(rowData);
                    },
                  },
                  /*  {
                    icon: "edit",
                    tooltip: "Editar",
                    onClick: (event, rowData) => {
                      setOpenEdit(true);
                      setIdRow(rowData);
                    },
                  },
                  {
                    icon: "delete",
                    tooltip: "Eliminar",
                    onClick: (event, rowData) => {
                      setOpenDelete(true);
                      setIdRow(rowData);
                    },
                  },*/
                  /*(rowData1) => ({
                    icon: () => <HighlightOff style={{ color: "red" }} />,
                    tooltip: "Deshabilitar",
                    onClick: (event, rowData) => {
                      //  setOpenDeshabilitar(true);
                      // setIdRow(rowData.id);
                    },
                    hidden: rowData1.status === 1 ? false : true,
                  }),
                  (rowData2) => ({
                    icon: () => <AddCircleOutline style={{ color: "green" }} />,
                    tooltip: "Habilitar",
                    onClick: (event, rowData) => {
                      // setOpenHabilitar(true);
                      // setIdRow(rowData.id);
                    },
                    hidden: rowData2.status === 0 ? false : true,
                  }),*/
                  {
                    icon: "refresh",
                    tooltip: "Refresh Data",
                    isFreeAction: true,
                    onClick: () => RefreshTable(),
                  },
                ]}
                icons={tableIcons}
                options={{
                  search: true,
                  padding: "default",
                  filtering: false,
                  actionsColumnIndex: -1,
                  pageSize: 10,
                  headerStyle: {
                    background: "#F2F2F2",
                    padding: "1%",
                    fontWeight: "bold",
                    textAlign: "center",
                  },
                  cellStyle: { border: "1px solid #DDDDDD" },
                }}
              />
            )}
          </CardBody>
        </Card>
      </GridItem>
      {openView ? (
        <View open={openView} exit={handleCloseView} id={idRow} />
      ) : (
        ""
      )}
      {/* {openEdit ? (
        <EditCar open={openEdit} exit={handleCloseEdit} id={idRow}  callBackRefresh={RefreshTable} />
      ) : (
        ""
      )}
      {openDelete ? (
        <DeleteCar
          open={openDelete}
          exit={handleCloseDelete}
          id={idRow}
          callBackRefresh={RefreshTable}
        />
      ) : (
        ""
      )}*/}
      {openLocation ? (
        <Location
          open={openLocation}
          exit={handleCloseLocation}
          id={idRow}
          latitude={latitude}
          longitude={longitude}
          nombre={nombre}
        />
      ) : (
        ""
      )}
      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </GridContainer>
  );
}
